import { createType } from './create-type.js';
import { StringTypeDescription } from './string-type-description.js';

export const string: () => StringTypeDescription<string> = () =>
  createType<StringTypeDescription>({
    description: { type: 'string' },
  });
